<template>
  <div ref="preview">
    <div class="md4">
      <div class="right-side-container preview_mainsection">
        <div class="header">
          <div class="header_preview_text">
            <p>Preview</p>
            <p v-if="myprops.showTagLine && !myprops.previewTagLine" class="header_preview_tag_line">Click the Review Tab to see how your reviews
              will be displayed</p>
            <p v-if="myprops.previewTagLine" class="header_preview_tag_line">{{ myprops.previewTagLine }}</p>
          </div>
          <span id="preview-background-color" v-if="checkBackground">
            <p class="header_preview_tag_line">Background Colour</p>
            <verte position="left" picker="square" :showHistory="false" v-model="myprops.previewBackground"
                   name="preview-background-color" model="hex">
                        </verte>
        </span>
          <h6 class="is-size-7 icon-container title-business responsive-action noselect">
                    <span class="desktop-icon"
                          v-on="isActive ? { click: () => responsive('desktop') } : {click: ($event) => $event.preventDefault() }"
                          :class="{ 'has-text-weight-bold active': !isActive }">
                          <img class="ds1" src="/static/img/desktop_white.png" srcset="/static/img/desktop_white@3x.png, /static/img/desktop_white@2x.png, /static/img/desktop_white.png"/>
                          <img class="ds2" data="/static/img/desktop_grey.png" srcset="/static/img/desktop_grey@3x.png, /static/img/desktop_grey@2x.png, /static/img/desktop_white.png"/>
                    </span>
                    <span class="mob-icon"
                      v-on="!isActive ? { click: () => responsive('mobile') } : {click: ($event) => $event.preventDefault() }"
                      :class="{ 'has-text-weight-bold active': isActive }">&nbsp;
                        <img class="mb1" src="/static/img/mobile_white.png" srcset="/static/img/mobile_white@3x.png, /static/img/mobile_white@2x.png,/static/img/mobile_white.png" />
                        <img class="mb2" src="/static/img/mobile_grey.png" srcset="/static/img/mobile_grey@3x.png, /static/img/mobile_grey@2x.png,/static/img/mobile_grey.png"/>
                      </span>
          </h6>
        </div>
        <div
          :style="{background:myprops.widget_background_color === 'transparent' ? myprops.previewBackground + '!important': 'transparent'}"
          class="preview-com vertical-30" :class="previewWidth" ref="star">
          <div class="preview_transparent_bg">
            <iframe id="iframed" ref="iframed"
                    :height="myprops.previewIframeHeight ? myprops.previewIframeHeight : '484px'"
                    :width="calculatedWidth"
                    :src="currentWidgetPreviewPath() + '&isPreview=' + isPreview"
                    v-on:load="iframeclick()"
                    @click.prevent="iframeclick">
            </iframe>
          </div>
          <modal-iframe :url="currentWidgetPreviewPath()" :iframe_class="widgetTypeClass" v-if="showPop && isDesktop"></modal-iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-undef */
  import ModalIframe from './ModalIframe'
  import verte from 'verte'
  import 'verte/dist/verte.css'

  export default {
    components: {ModalIframe, verte},
    props: ['myprops'],
    data () {
      return {
        isActive: false,
        currentWidget: this.$router.currentRoute.path,
        widgetTypeClass: this.$router.currentRoute.params.type,
        showPop: false,
        isPreview: false,
        isSeoPreview: false,
        isDesktop: true,
        previewWidth: 'width-80',
        slug: localStorage.getItem('org_slug'),
        previewWidthPercent: 'width-80-percent'
      }
    },
    created () {
      window.events.$on('closingModal', this.CloseModal)
      window.addEventListener('previewModalClose', this.CloseModal)
      window.events.$on('closePop', this.CloseModal)
    },
    destroyed () {
      window.events.$off('closingModal')
      window.events.$off('closePop')
    },
    computed: {
      calculatedWidth () {
        if (this.widgetTypeClass === 'reviewSlider') {
          return '100%'
        }
        if (this.myprops.dimension) {
          return parseInt(this.myprops.dimension) + 20
        } else {
          return this.myprops.previewIframeWidth ? this.myprops.previewIframeWidth : '600px'
        }
      },
      checkBackground () {
        return this.myprops.widget_background_color === 'transparent'
      },
      reviewTab () {
        let params = encodeURIComponent(JSON.stringify(this.myprops))
        return process.env.APP_URL + '/static/index.html?params=' + params + '&preview=' + this.isPreview + '&search=' + this.slug + '&appUrl=' + process.env.APP_URL + '&apiUrl=' + process.env.API_URL + '&appFront=' + process.env.HP_APP_URL
      },
      dropDown () {
        let params = encodeURIComponent(JSON.stringify(this.myprops))
        return process.env.APP_URL + '/static/dropDown.html?params=' + params + '&preview=' + this.isPreview + '&search=' + this.slug + '&appUrl=' + process.env.APP_URL + '&apiUrl=' + process.env.API_URL + '&appFront=' + process.env.HP_APP_URL
      },
      onSiteWriteReview () {
        let params = encodeURIComponent(JSON.stringify(this.myprops))
        return process.env.APP_URL + '/static/onsiteReview.html?params=' + params + '&preview=' + this.isPreview + '&search=' + this.slug + '&appUrl=' + process.env.APP_URL + '&apiUrl=' + process.env.API_URL + '&appFront=' + process.env.HP_APP_URL
      },
      reviewBadge () {
        let params = encodeURIComponent(JSON.stringify(this.myprops))
        return process.env.APP_URL + '/static/verifiedBadge.html?params=' + params + '&preview=' + this.isPreview + '&search=' + this.slug + '&appUrl=' + process.env.APP_URL + '&apiUrl=' + process.env.API_URL + '&appFront=' + process.env.HP_APP_URL
      },
      verifiedSiteBadge () {
        let params = encodeURIComponent(JSON.stringify(this.myprops))
        return process.env.APP_URL + '/static/verifiedSiteBadge.html?params=' + params + '&preview=' + this.isPreview + '&search=' + this.slug + '&appUrl=' + process.env.APP_URL + '&apiUrl=' + process.env.API_URL + '&appFront=' + process.env.HP_APP_URL
      },
      ribbonBadge () {
        let params = encodeURIComponent(JSON.stringify(this.myprops))
        return process.env.APP_URL + '/static/ribbonBadge.html?params=' + params + '&preview=' + this.isPreview + '&search=' + this.slug + '&appUrl=' + process.env.APP_URL + '&apiUrl=' + process.env.API_URL + '&appFront=' + process.env.HP_APP_URL
      },
      metricDisplayBadge () {
        let params = encodeURIComponent(JSON.stringify(this.myprops))
        return process.env.APP_URL + '/static/metricReviewBadge.html?params=' + params + '&preview=' + this.isPreview + '&search=' + this.slug + '&appUrl=' + process.env.APP_URL + '&apiUrl=' + process.env.API_URL + '&appFront=' + process.env.HP_APP_URL
      },
      verticalFeed () {
        let params = encodeURIComponent(JSON.stringify(this.myprops))
        return process.env.APP_URL + '/static/verticalFeed.html?params=' + params + '&preview=' + this.isPreview + '&search=' + this.slug + '&appUrl=' + process.env.APP_URL + '&apiUrl=' + process.env.API_URL + '&appFront=' + process.env.HP_APP_URL
      },
      reviewSlider () {
        let params = encodeURIComponent(JSON.stringify(this.myprops))
        return process.env.APP_URL + '/static/reviewSlider.html?params=' + params + '&preview=' + this.isPreview + '&search=' + this.slug + '&appUrl=' + process.env.APP_URL + '&apiUrl=' + process.env.API_URL + '&appFront=' + process.env.HP_APP_URL
      },
      seoPage () {
        let params = encodeURIComponent(JSON.stringify(this.myprops))
        return process.env.APP_URL + '/static/seoPage.html?params=' + params + '&preview=' + this.isPreview + '&search=' + this.slug + '&appUrl=' + process.env.APP_URL + '&apiUrl=' + process.env.API_URL + '&appFront=' + process.env.HP_APP_URL
      },
      carousel () {
        let params = encodeURIComponent(JSON.stringify(this.myprops))
        return process.env.APP_URL + '/static/carousel.html?params=' + params + '&preview=' + this.isPreview + '&search=' + this.slug + '&appUrl=' + process.env.APP_URL + '&apiUrl=' + process.env.API_URL + '&appFront=' + process.env.HP_APP_URL
      }
    },
    methods: {
      currentWidgetPreviewPath () {
        let widgetType = this.$router.currentRoute.params.type
        return this[widgetType]
      },
      /**
       * close pop
       * @return {void}
       */
      CloseModal () {
        this.isPreview = false
        this.showPop = false
      },
      /**
       * display the popup on click of button
       * @return {void}
       */
      iframeclick () {
        setTimeout(() => {
          let iframe = document.getElementById('iframed').contentWindow
          if (iframe !== null) {
            let clickable = iframe.document.getElementById('hp-widget-hp-ctn-howItWorks')
            if (clickable == null) {
              clickable = iframe.document.getElementById('btn-write-review2')
              if (clickable !== null) {
                this.isPreview = true
                return false
              }
            } else {
              clickable.onclick = () => {
                this.isPreview = true
                this.showPop = this.isDesktop
              }
            }
          }
        }, 5000)
      },
      /**
       * Toggle between Desktop and mobile preview
       * @param {string} type device type
       * @returns {void}
       */
      responsive (type) {
        this.isActive = !this.isActive
        if (type === 'desktop') {
          this.previewWidth = 'width-80'
          this.isDesktop = true
        } else {
          this.previewWidth = 'width-mob'
          this.isDesktop = false
        }
        this.myprops.isMobile = !this.myprops.isMobile
      }
    }
  }
</script>
<style scoped>

.vertical_feed_preview iframe {
  margin: -11px auto 0 auto;
  margin-top: 11px;
}

.mob-icon img {
  max-height: 22px;
}

  .md4.verified_review_badge_container .preview-com {
    margin-top: 0px !important;
  }

  #preview-background-color {
    width: 154px;
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  .verified_review_badge_container #preview-background-color {

  }

  #preview-background-color p {
    margin-right: 10px;
  }

  .md4.verified_review_badge_container .preview-com iframe {
    display: block;
    margin: 0px auto;
  }

  .md4.verified_review_badge_container .right-side-container {
    padding-bottom: 0px !important;
  }

  .preview_transparent_bg {
    display: contents;
  }

  .desktop-icon {
    width: 60px;
    display: flex;
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
    align-items: center;
    justify-content: center;
    padding: 9px;
  }

  .mob-icon {
    width: 60px;
    display: flex;
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
    align-items: center;
    justify-content: center;
    padding: 9px;
  }

  .mob-icon.active {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .desktop-icon.active {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  #top-reviews-carousel {
    border: 1px solid #ccc;
    border-top: 1px solid #ccc !important;
    margin-bottom: 30px;
    margin: auto;
  }

  .right-side-container {
    background-repeat: no-repeat !important;
    background-size: 100% !important;
    padding-bottom: 50px;
  }

  .preview-com {
    min-height: 500px;
    background: transparent !important;
    margin-top: 80px !important;
    margin: 1px auto;
  }

  .preview-com.width-mob {
    min-height: 484px !important;
  }

  .width-40 {
    width: 215px
  }

  .width-80 {
    width: 100%
  }

  .width-80-percent {
    width: 100%
  }

  .width-mob {
    width: 314px;
    background-color: #fff !important;
  }

  .width-mob-306 {
    width: 306px !important;
  }

  .right-side-container {
    min-height: 500px;
    height: 90%;
    width: 519px !important;
    background: url('/static/img/preview-background.png');
  }

  .vertical_feed_preview .right-side-container {
    min-height: 200px !important;
    height: 443px !important ;
    width: 100% !important;
    background: url('/static/img/preview-background.png');
  }

  .right-side-container .header {
    background-color: #f0f0f0;
    object-fit: contain;
    height: 55px;
    width: 100%;
    padding: 0 20px;
    display: flex;
    align-items: center;
  }

  .right-side-container .header p {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
  }

  .main-container-full .right-side-container {
    min-height: 500px !important;
    height: 90%;
    width: 100% !important;
    background: url('/static/img/Preview_background.svg') !important;
  }

  .vertical_feed_preview .main-container-full .right-side-container {
    min-height: 200px !important;
    height: 90%;
    border: 1px solid #232323;
    width: 100% !important;
    background: url('/static/img/Preview_background.svg') !important;
  }
  .main-container-full .right-side-container .header {
    background-color: #f0f0f0;
    object-fit: contain;
    height: 55px;
    width: 100%;
    padding: 0 20px;
    display: flex;
    align-items: center;
  }

  .main-container-full .right-side-container .header p {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
  }

  .vertical_feed_preview .main-container-full .right-side-container .header .p{
    font-size: 14px !important;
  }

  p.header_preview_tag_line {
    font-size: 11px !important;
  }

  /** vertical feed */
  .vertical_feed_preview .right-side-container.preview_mainsection {
    /*min-height: 400px !important;*/
    height: 443px !important;
    padding-bottom:0px !important;
  }

  .vertical_feed_preview_high .right-side-container.preview_mainsection {
    min-height: 400px !important;
    height: 525px !important;
    padding-bottom:0px !important;
  }

  .vertical_feed_preview .right-side-container.preview_mainsection .preview-com {
    margin-top: 0px !important;
  }
  .vertical_feed_preview .preview-com.vertical-30.width-80 {
    min-height: 451px !important;
  }

  .vertical_feed_preview .preview-com.vertical-30.width-mob {
    min-height: 200px !important;
    width: 334px;
  }

  .main-container-full span#preview-background-color {
    float: right;
    position: absolute;
    right: 134px;
}

.seopage_preview .right-side-container.preview_mainsection {
  min-height: 400px !important;
  height: 573px !important;
  padding-bottom:0px !important;
}


.seopage_preview .right-side-container.preview_mainsection .preview-com.width-mob {
  margin-top: 41px !important;
}
.vertical_feed_preview .preview-com.vertical-30.width-80 {
  min-height: 451px !important;
}

.vertical_feed_preview .preview-com.vertical-30.width-mob {
  min-height: 200px !important;
  width: 334px;
}
.seopage_preview iframe,.seopage_preview iframe#iframed{width:100%;}
.seopage_preview .preview_mainsection .preview-com.width-mob {
  height: 434px !important;
}

.dropdown_preview iframe,.dropdown_preview iframe#iframed{width:100%; margin-top:60px;}
.dropdown_preview .preview_mainsection .preview-com {
  overflow: none;
}
.vertical_feed_preview.dropdown_preview .preview-com.vertical-30.width-80 {min-height: 340px !important;}
.dropdown_preview iframe, .dropdown_preview iframe#iframed {
  width: 100%;
  margin-top: 10px;
  margin-top: 10px;
}
body#hp-widget-vertical_feed_body{height:100%;}
body#hp-widget-review-slider-body{height:100%;}
div#hp-widget-drop-down.hp-320 {
  overflow: scroll;
  height: 100%;
  overflow-x: hidden;
}
.hp-widget-powered-by {
  padding-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/PreviewWidget.vue